import { render, staticRenderFns } from "./SfHero.vue?vue&type=template&id=2dd65658&"
import script from "./SfHero.vue?vue&type=script&lang=js&"
export * from "./SfHero.vue?vue&type=script&lang=js&"
import style0 from "./SfHero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports